import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { HrmEmployeeFilter, OrderGroup, SearchBox } from "@components";
import { TableColumn } from "./TableColumn";

import { usePunishments } from "@hooks/HRM/punishments/usePunishments";

import { TablePagination } from "@helpers/tablePagination";

export const PunishmentHistoryListTable = () => {
  const [activeStatus, setActiveStatus] = useState<number | null>(null);

  const { t } = useTranslation();

  const { control, register, setValue } = useForm();

  const { punishments, pagination, handleQuery, handleOrder, queryParams } =
    usePunishments();
  const { total } = pagination || {};

  const orderGroups = [
    {
      value: "dateOrder",
      label: t("PUNISHMENT_HISTORY_LIST.ORDERS.DATE"),
    },
  ];

  const status = ["dateOrder"];

  const ordGroupAction = (index: number) => {
    let statusId = 0;
    switch (index) {
      case 0:
        statusId = 0;
        break;
      default:
        statusId = 0;
        break;
    }
    setActiveStatus(statusId);
    handleOrder(status[statusId]);
  };

  const modifiedData = punishments?.map((punishment: any) => ({
    employeeID: punishment.employee.id,
    punishmentID: punishment?.id,
    ...punishment.employee,
    ...punishment,
  }));

  return (
    <div>
      <HrmEmployeeFilter
        handleQuery={handleQuery}
        control={control}
        register={register}
        setValue={setValue}
      />

      <Table
        columns={TableColumn(t) as any}
        rows={modifiedData}
        header={{
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
          title: t("PUNISHMENT_HISTORY_LIST.TABLE_HEADER.LABEL"),
        }}
        headerExtension={{
          leftComponents: [
            <OrderGroup
              key="btn-group"
              orderGroupData={orderGroups}
              activeState={activeStatus}
              action={ordGroupAction}
              query={queryParams}
            />,
          ],
          rightComponents: [
            <SearchBox
              key="search"
              control={control}
              handleQuery={handleQuery}
            />,
          ],
        }}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
